// import _ from "lodash";
import { addEightHour } from '@/util/index'
export const couponList = data => {
  return data.map(item => {
    // 券类型
    let typeName = ''
    // 优惠方式
    let discountStr = ''
    // 使用门槛
    let thresholdStr = ''
    let rightContent = item.rightContent
    // 使用限制
    let phaseStr = item.phaseTypeFlag == 1 ? `` : `每${item.phaseTypeName}可使用${item.phasedUseNum}次`
    let limitStr = item.userNumTypeFlag == 2 ? `使用1次` : item.totalUseNum > 0 ? `共可使用${item.totalUseNum}次 ${phaseStr}` : `不限使用次数${phaseStr}`
    // console.log(object);
    item.activeEndTime = addEightHour(item.activeEndTime, 'day', '.')
    item.activeStartTime = addEightHour(item.activeStartTime, 'day', '.')
    switch (item.rightTypeFlag) {
      case 1:
        //满减券金额类-整单减
        typeName = '满减券'
        discountStr = `￥${rightContent.subtractPrice}`
        thresholdStr = `满￥${rightContent.fullPrice}使用`
        break
      case 2:
        //满减券金额类-每满减
        typeName = '满减券'
        discountStr = `￥${rightContent.subtractPrice}`
        thresholdStr = `每满￥${rightContent.everyFullPrice}使用`
        break
      case 3:
        //满减券产品类-整单减
        typeName = '满减券'
        discountStr = `减${rightContent.subtractNum}件`
        thresholdStr = `满${rightContent.fullNum}件使用`
        break
      case 4:
        //满减券产品类-每满减
        typeName = '满减券'
        discountStr = `减${rightContent.subtractNum}件`
        thresholdStr = `每满${rightContent.everyFullNum}件使用`

        break
      case 5:
        //满减券(满件数减金额)-整单减
        typeName = '满减券'
        discountStr = `￥${rightContent.subtractPrice}`
        thresholdStr = `满${rightContent.fullNum}件使用`
        item.tyreThresholdStr = `满${rightContent.fullNum}件减${rightContent.subtractPrice}`

        break
      case 6:
        //满减券(满件数减金额)-每满减
        typeName = '满减券'
        discountStr = `￥${rightContent.subtractPrice}`
        thresholdStr = `每满${rightContent.everyFullNum}件使用`

        break
      case 7:
        // 折扣券
        typeName = '折扣券'
        discountStr = `${rightContent.discount}折`
        thresholdStr = rightContent.fullPrice > 0 ? `满￥${rightContent.fullPrice}使用` : '无使用门槛'

        break
      case 8:
        // 赠品券
        typeName = '赠品券'
        discountStr = `${rightContent.givingNum}件`
        thresholdStr = '购买指定商品'

        break
      case 9:
        // 免单券
        typeName = '免单券'
        discountStr = '整单免'
        thresholdStr = '限免1件'

        break
      case 10:
        // 代金券
        typeName = '代金券'
        discountStr = `￥${rightContent.vouchers}`
        thresholdStr = '无使用门槛'

        break
      case 11: {
        // 动态折扣券
        typeName = '动态折扣券'
        // discountStr = `低至${
        // _.min(rightContent.content, "discount").discount
        // }折`;
        thresholdStr = '无使用门槛'
        const sortArr = rightContent.content.sort((a, b) => Number(a.discount) - Number(b.discount))
        const discountTemp = sortArr[0] && sortArr[0].discount ? sortArr[0].discount : ''
        discountStr = `低至${discountTemp}折`
        break
      }
      case 12: {
        // 体验券
        discountStr = '体验券'
        break
      }
      case 13: {
       // 动态折扣券
       typeName = '区间动态折扣券'
       // discountStr = `低至${
       // _.min(rightContent.content, "discount").discount
       // }折`;
       thresholdStr = '无使用门槛'
       const sortArr = rightContent.content.sort((a, b) => Number(a.discount) - Number(b.discount))
       const discountTemp = sortArr[0] && sortArr[0].discount ? sortArr[0].discount : ''
       discountStr = `低至${discountTemp}折`
       break
      }
      case 14:
        //满减券-满件折
        typeName = '满减券'
        discountStr = `${rightContent.discount} 折`
        thresholdStr = `仅${rightContent.minNum}件使用`

        break
    }
    item.typeName = typeName
    item.discountStr = discountStr
    item.thresholdStr = thresholdStr
    item.limitStr = limitStr
    return item
  })
}

export const couponName = item => {
  let result = ''
  switch (item.statusFlag) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      result = '满减券'
      break
    case 7:
      result = '折扣券'
      break
    case 8:
    case 9:
      result = '赠品券'
      break
    case 10:
      result = '代金券'
      break
    case 11:
      result = '动态折扣券'
      break
  }
  return result
}
